import React, { useContext } from "react";
import { CanvasContext } from "../../contexts/CanvasContext";
import {
  FaFacebook,
  FaInstagram,
  FaLinkedin,
  FaGithub,
  FaDiscord,
} from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import "./LandingFooter.css";

const LandingFooter = () => {
  const { isDarkTheme } = useContext(CanvasContext);

  return (
    <footer
      className={`animated-landing-footer__container ${
        isDarkTheme ? "dark-theme" : ""
      }`}
    >
      <div className="animated-landing-footer__content">
        <div className="animated-landing-footer__row">
          <div className="animated-landing-footer__col animated-landing-footer__brand-section">
            <div className="animated-landing-footer__logo">
              <div className="animated-logo">
                <span className="logo-text">NexGen Sites</span>
              </div>
            </div>
            <p className="animated-landing-footer__brand-description">
              Your Gateway to Next-Gen Web Solutions
            </p>
            <p className="animated-landing-footer__brand-subtext">
              Innovating the Future of Web Development
            </p>
          </div>
          <div className="animated-landing-footer__col">
            <h3 className="animated-landing-footer__column-title">Site Map</h3>
            <ul className="animated-landing-footer__link-list">
              <li>
                <a href="/home" className="animated-landing-footer__link">
                  Home
                </a>
              </li>
              <li>
                <a href="/about" className="animated-landing-footer__link">
                  About
                </a>
              </li>
              <li>
                <a href="/services" className="animated-landing-footer__link">
                  Services
                </a>
              </li>
              <li>
                <a href="/contact" className="animated-landing-footer__link">
                  Contact
                </a>
              </li>
            </ul>
          </div>
          <div className="animated-landing-footer__col">
            <h3 className="animated-landing-footer__column-title">Follow Us</h3>
            <ul className="animated-landing-footer__link-list">
              <li>
                <a
                  href="https://www.facebook.com/prince.gondliya.5"
                  className="animated-landing-footer__link"
                >
                  <FaFacebook /> <span>Facebook</span>
                </a>
              </li>
              <li>
                <a
                  href="https://www.instagram.com/_prince_patel20/"
                  className="animated-landing-footer__link"
                >
                  <FaInstagram /> <span>Instagram</span>
                </a>
              </li>
              <li>
                <a
                  href="https://www.linkedin.com/in/prince-gondaliya-968126229?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"
                  className="animated-landing-footer__link"
                >
                  <FaLinkedin /> <span>LinkedIn</span>
                </a>
              </li>
              <li>
                <a
                  href="https://x.com/Princepatel2031"
                  className="animated-landing-footer__link"
                >
                  <FaXTwitter /> <span>Twitter</span>
                </a>
              </li>
              <li>
                <a
                  href="https://discord.com/channels/@me"
                  className="animated-landing-footer__link"
                >
                  <FaDiscord /> <span>Discord</span>
                </a>
              </li>
              <li>
                <a
                  href="https://github.com/Princepatel20"
                  className="animated-landing-footer__link"
                >
                  <FaGithub /> <span>GitHub</span>
                </a>
              </li>
            </ul>
          </div>
          <div className="animated-landing-footer__col">
            <h3 className="animated-landing-footer__column-title">
              Our Services
            </h3>
            <ul className="animated-landing-footer__link-list">
              <li>
                <a
                  href="/services/digital-marketing"
                  className="animated-landing-footer__link"
                >
                  Digital Marketing
                </a>
              </li>
              <li>
                <a
                  href="/services/web-development"
                  className="animated-landing-footer__link"
                >
                  Web Development
                </a>
              </li>
              <li>
                <a
                  href="/services/graphic-design"
                  className="animated-landing-footer__link"
                >
                  Graphic Design
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="animated-landing-footer__bottom">
          <p className="animated-landing-footer__copyright">
            &copy; 2025 Created By: NexGen Sites
          </p>
          <div className="animated-landing-footer__legal-links">
            <a
              href="/terms-of-use"
              className="animated-landing-footer__legal-link"
            >
              Terms Of Use
            </a>
            <a
              href="/privacy-policy"
              className="animated-landing-footer__legal-link"
            >
              Privacy Policy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default LandingFooter;
